import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import axiosBaseQueryUserMangement from './axiosBaseQueryUserMangement';

// Define a service using a base URL and expected endpoints
export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: axiosBaseQueryUserMangement({ baseUrl: process.env.REACT_APP_USER_MANAGEMENT_BASE_URL }),
  tagTypes: ['auth'],
  endpoints: (builder) => ({
    loginUser: builder.mutation({
      query: (body) => {
        return {
          url: '/login',
          method: 'POST',
          body: body,
        };
      },
    }),
    // logoutUser: builder.query({
    //   query: () => '/logout',
    // }),
    merchentUser: builder.mutation({
      query: (body) => {
        return {
          url: '/saveMerchant',
          method: 'POST',
          body: body,
        };
      },
    }),
    ssoLoginUser: builder.mutation({
      query: (body) => {
        return {
          url: '/ssoLogin',
          method: 'POST',
          body: body,
        };
      },
    }),
    permissions: builder.query({
      query: (body) => {
        return {
          url: '/permissions',
          method: 'GET',
          body: body,
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLoginUserMutation
  // , useLogoutUserQuery
 } = authApi;
